import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { NgOtpInputComponent } from "ng-otp-input";
import { ConfirmationService } from "primeng/api";
import { GeneralResModel, MenuItem } from "src/app/_models";
import { User } from "src/app/_models/user-models/user";
import { AppMenuService, LocalStorageService } from "src/app/_services";
import { AuthService } from "src/app/_services/auth/auth.service";
import { AlertifyService } from "src/app/_services/common/alertify.service";
import { AppSessionState } from "src/app/_services/common/app.service";
import { DataService } from "src/app/_services/data-service/data.service";
import { login } from "src/app/_store/actions/login.actions";
import { UserSessionStateModel } from "src/app/_store/models/user-session-state.model";
import { AppConstant } from "src/app/shared/webdatarocks/app.constant";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-two-factor-auth-verify",
  templateUrl: "./two-factor-auth-verify.component.html",
  styleUrls: ["./two-factor-auth-verify.component.scss"],
})
export class TwoFactorAuthVerifyComponent implements OnInit {
  client: User;
  dark: boolean;
  loginModel: any = {};
  TotpVerifyCode: string;
  isCloud: boolean = true;
  isDisabled: boolean = false;
  selectedTwoFaCode: string = "";
  twoFAVerifyrequest: User = new User();
  selectedTwoFaCodeForBackup: string = "";
  isVisibleSigninRecoverCodePanel: boolean = false;
  @ViewChild("otpInputForInstantCode")
  otpInputForInstantCode: NgOtpInputComponent;
  @ViewChild("otpInputForRecoverCode")
  otpInputForRecoverCode: NgOtpInputComponent;

  menuData: MenuItem[] = [];
   getUser: User = new User();

  constructor(
    private _router: Router,
    private _store: Store<any>,
    private _dataService: DataService,
    private _authService: AuthService,
    private _alertify: AlertifyService,
    private _appSessionState: AppSessionState,
    private _confirmationService: ConfirmationService,
    private _appMenuService: AppMenuService
  ) {}

  ngOnInit(): void {
    // localStorage.clear();
        this.loginModel = LocalStorageService.getStorageValueWithParse(
            AppConstant.LoginRequestModel
        );
  }

  onTwoFaCodeChange(code) {
    this.selectedTwoFaCode = code;
  }

  onTwoFaCodeChangeForBackup(backupCode) {
    this.selectedTwoFaCodeForBackup = backupCode;
  }

  verifyCode() {
    this.login();
  }

  verifyForRecoverCode() {
    this.login();
  }

  selectedTwoFaCodeValid(x): boolean {
    if (x === "backupCode") {
      return this.selectedTwoFaCodeForBackup.length === 6;
    } else {
      return this.selectedTwoFaCode.length === 6;
    }
  }

  cancelSigningIn() {
    this.routeToLoginScreen();
  }

  signinWithRecoverCode() {
    this.isVisibleSigninRecoverCodePanel = true;
  }

  private routeToStudyWorklist() {
    this._router.navigate(["/study/worklist"]);
  }

  private routeToLoginScreen() {
    this._router.navigate(["/login"]);
  }

  closeSigninRecoverCodePanle() {
    this.resetOtpInput();
    this.isVisibleSigninRecoverCodePanel = false;
  }

  private resetOtpInput() {
    if (this.selectedTwoFaCodeForBackup != null) {
      this.otpInputForRecoverCode.setValue("");
    } else if (this.selectedTwoFaCode != null) {
      this.otpInputForInstantCode.setValue("");
    } else {
      return;
    }
  }

  private login() {
    this._authService.login( this.loginModel).subscribe(
      (data) => {
        if (data) {
           this.getUser = data.Result;
          if (this.getUser.IsSuperAdmin) {
            environment.isSuperAdmin = true;
          }

          if (this.getUser.JobType == "A") {
            environment.isSiteAdmin = true;
          }

            this._appSessionState.setToken(
            this.getUser.TokenString,
            <User>this.getUser,
            "" + new Date()
          );

          // this._appSessionState.setToken(
          //   data.tokenString,
          //   <User>data.userRights,
          //   "" + new Date()
          // );

          this._appSessionState.setUserToSessionStorage(this.getUser);
          localStorage.setItem("immediateReport", "true");
          this.setUserSessionState(data);

          this.client = JSON.parse(localStorage.getItem("user"));

          if (this.client != null) {
            if (
              this.selectedTwoFaCode === "" ||
              this.selectedTwoFaCode === null
            ) {
              this.twoFAVerifyrequest = this.client;
              this.twoFAVerifyrequest.TotpVerifyCode =
                this.selectedTwoFaCodeForBackup;
              this._authService
                .user2faAuthBackupCodesVerify(this.twoFAVerifyrequest)
                .subscribe((res: GeneralResModel<User>) => {
                  if (res.IsSucceed) {
                    this.closeSigninRecoverCodePanle();
                    this.twoFAVerifyrequest = new User();

                    this._confirmationService.confirm({
                      key: "confirmTwoFADisable",
                      message: "Do you want to disable 2FA on your Account?",
                      accept: () => {
                        this._authService
                          .user2faAuthDisable(this.client.EmpId)
                          .subscribe((res: GeneralResModel<string>) => {
                            if (res.IsSucceed) {
                              this._alertify.success(
                                "2FA has been successfully disabled from your profile."
                              );

                              //this.routeToStudyWorklist();
                              this.getMenuList(this.client.EmpId);
                              this._alertify.success("Logged in successfully.");
                            } else {
                              this._alertify.error(res.Message);
                            }
                          });
                      },
                      reject: () => {
                        //this.routeToStudyWorklist();
                        this.getMenuList(this.client.EmpId);
                        this._alertify.success("Logged in successfully.");
                        return;
                      },
                    });
                  } else {
                    this.twoFAVerifyrequest = new User();
                    this._alertify.error(res.Message);
                  }
                });
            } else {
              this.twoFAVerifyrequest = this.client;
              this.twoFAVerifyrequest.TotpVerifyCode = this.selectedTwoFaCode;
              this._authService
                .getUser2faAuthVerifyingTOTP(this.twoFAVerifyrequest)
                .subscribe((res: boolean) => {
                  if (res) {
                    this.twoFAVerifyrequest = new User();
                    // Arifur (27-01-2025): This is the place where we need to call the getMenuList method
                    // this.getMenuList(this.client.EmpId);
                    //this.routeToStudyWorklist();
                    // this._alertify.success("Logged in successfully.");
                    this.getMenuList(this.client.EmpId);
                  } else {
                    this.twoFAVerifyrequest = new User();
                    this._alertify.error(
                      "Please enter valid code within 30 seconds."
                    );
                  }
                });
            }
          }
        }
      },
      (error) => {
        this._alertify.error("Failed to login");
      }
    );
  }

  private getMenuList(empId: number) {
    this._appMenuService
      .getMenuList(empId)
      .subscribe((res: GeneralResModel<MenuItem[]>) => {
        if (res.IsSucceed) {
          this.menuData = res.Result;

          this.menuData = this.menuData.map((item) => {
            return this.setMenuItemsNullIfEmpty(item);
          });

          localStorage.setItem("MENU", JSON.stringify(this.menuData));

          if (this.menuData.length > 0) {
            let defaultURL =
              this.client.LandingPageUrl ||
              this.menuData.find((x) =>
                x.routerLink?.includes("/study/worklist")
              )?.routerLink?.[0] ||
              this.menuData[0]?.routerLink?.[0];

            if (defaultURL) {
              this.routeToLandingPage(defaultURL);
            }

            this._alertify.success("Logged in successfully.");
          } else {
            this._alertify.error(
              "You do not have permission to access the menu. Please contact the administrator."
            );
          }
        }
      });
  }

  private routeToLandingPage(url: string | null | undefined): void {
    const defaultRoute = "/study/order";
    const route = url?.trim().toLowerCase() || defaultRoute;
    this._router.navigate([route]);
  }

  private setMenuItemsNullIfEmpty(item: any): any {
    if (item.items && item.items.length === 0) {
      item.items = null;
    } else if (item.items && item.items.length > 0) {
      item.items = item.items.map((subItem) => {
        return this.setMenuItemsNullIfEmpty(subItem);
      });
    }
    return item;
  }

  private setUserSessionState(data) {
    let loginModel: UserSessionStateModel = {
      LoginTime: new Date(),
      UserInfo: data.user,
    };
    this._store.dispatch(login({ userSessionDetail: loginModel }));
  }
}
